// src/asleepPositions.js

// Allar flugurnar – normalized 0–1 (byggt á 1920x1080)
export const FLY_SLOTS_DESKTOP = [
{ x: 0.279, y: 0.198 },
{ x: 0.369, y: 0.17 },  // 709x184
{ x: 0.42, y: 0.172 },  // 806x186
{ x: 0.466, y: 0.073 },  // 894x79
{ x: 0.499, y: 0.178 },  // 959x192
{ x: 0.54, y: 0.139 },  // 1037x150
{ x: 0.572, y: 0.088 },  // 1099x95
{ x: 0.697, y: 0.262 },  // 1339x283
{ x: 0.577, y: 0.205 },  // 1107x221
{ x: 0.452, y: 0.219 },  // 869x237
{ x: 0.403, y: 0.235 },  // 773x254
{ x: 0.278, y: 0.346 },  // 534x374
{ x: 0.418, y: 0.341 },  // 803x368
{ x: 0.475, y: 0.336 },  // 912x363
{ x: 0.528, y: 0.347 },  // 1014x375
{ x: 0.577, y: 0.286 },  // 1108x309
{ x: 0.628, y: 0.349 },  // 1206x377
{ x: 0.825, y: 0.28 },  // 1585x303
{ x: 0.817, y: 0.421 },  // 1569x455
{ x: 0.748, y: 0.498 },  // 1435x537
{ x: 0.659, y: 0.47 },  // 1265x508
{ x: 0.552, y: 0.462 },  // 1061x499
{ x: 0.499, y: 0.434 },  // 958x468
{ x: 0.396, y: 0.407 },  // 760x440
{ x: 0.33, y: 0.446 },  // 634x482
{ x: 0.261, y: 0.514 },  // 501x555
{ x: 0.188, y: 0.555 },  // 362x599
{ x: 0.302, y: 0.601 },  // 579x649
{ x: 0.383, y: 0.559 },  // 734x603
{ x: 0.484, y: 0.566 },  // 929x612
{ x: 0.527, y: 0.623 },  // 1012x673
{ x: 0.564, y: 0.577 },  // 1083x623
{ x: 0.614, y: 0.617 },  // 1179x666
{ x: 0.674, y: 0.577 },  // 1294x623
{ x: 0.717, y: 0.678 },  // 1377x732
{ x: 0.645, y: 0.689 },  // 1238x744
{ x: 0.592, y: 0.708 },  // 1137x765
{ x: 0.516, y: 0.728 },  // 991x786
{ x: 0.44, y: 0.728 },  // 844x786
{ x: 0.376, y: 0.721 },  // 721x779
{ x: 0.314, y: 0.702 },  // 602x758
{ x: 0.247, y: 0.701 },  // 474x757
{ x: 0.141, y: 0.816 },  // 271x882
{ x: 0.266, y: 0.803 },  // 511x868
{ x: 0.324, y: 0.85 },  // 623x918
{ x: 0.385, y: 0.828 },  // 739x894
{ x: 0.44, y: 0.914 },  // 845x987
{ x: 0.552, y: 0.781 },  // 1061x843
{ x: 0.635, y: 0.774 },  // 1220x836
{ x: 0.744, y: 0.763 }  // 1429x824
];

// Hversu margar rásir með audio:
// Mars:  11 stems
// Palli: 8 stems
// Agust: 7 stems
// Siggi: 7 stems
// Mobile slots fyrir portrait layout (1080x1920)
// Byrjar sem copy, þú mátt svo yfirskrifa þegar þú ert búinn að mappa upp
export const FLY_SLOTS_MOBILE = [
 { x: 0.174, y: 0.145 },  // 334x157
 { x: 0.441, y: 0.187 },  // 846x202
 { x: 0.191, y: 0.265 },  // 366x286
 { x: 0.298, y: 0.246 },  // 571x265
 { x: 0.484, y: 0.26 },  // 929x281
 { x: 0.649, y: 0.277 },  // 1246x300
 { x: 0.801, y: 0.284 },  // 1538x307
 { x: 0.145, y: 0.328 },  // 279x355
 { x: 0.295, y: 0.315 },  // 566x340
 { x: 0.393, y: 0.305 },  // 755x330
 { x: 0.481, y: 0.328 },  // 923x355
 { x: 0.554, y: 0.323 },  // 1064x348
 { x: 0.088, y: 0.44 },  // 168x475
 { x: 0.163, y: 0.389 },  // 312x420
 { x: 0.267, y: 0.377 },  // 512x407
 { x: 0.437, y: 0.385 },  // 838x415
 { x: 0.499, y: 0.382 },  // 959x412
 { x: 0.588, y: 0.392 },  // 1129x423
 { x: 0.653, y: 0.418 },  // 1254x452
 { x: 0.822, y: 0.371 },  // 1578x401
 { x: 0.917, y: 0.458 },  // 1760x495
 { x: 0.786, y: 0.452 },  // 1509x489
 { x: 0.662, y: 0.48 },  // 1271x518
 { x: 0.505, y: 0.47 },  // 969x507
 { x: 0.437, y: 0.488 },  // 838x527
 { x: 0.274, y: 0.44 },  // 526x475
 { x: 0.2, y: 0.457 },  // 384x494
 { x: 0.178, y: 0.495 },  // 342x534
 { x: 0.264, y: 0.511 },  // 506x552
 { x: 0.376, y: 0.523 },  // 722x565
 { x: 0.465, y: 0.537 },  // 894x580
 { x: 0.536, y: 0.548 },  // 1028x592
 { x: 0.655, y: 0.529 },  // 1258x572
 { x: 0.816, y: 0.501 },  // 1566x541
 { x: 0.853, y: 0.543 },  // 1637x587
 { x: 0.913, y: 0.577 },  // 1754x623
 { x: 0.715, y: 0.583 },  // 1372x629
 { x: 0.647, y: 0.631 },  // 1242x681
 { x: 0.513, y: 0.598 },  // 985x646
 { x: 0.423, y: 0.565 },  // 813x611
 { x: 0.284, y: 0.593 },  // 546x641
 { x: 0.217, y: 0.553 },  // 417x597
 { x: 0.197, y: 0.59 },  // 378x638
 { x: 0.109, y: 0.603 },  // 210x651
 { x: 0.23, y: 0.638 },  // 441x689
 { x: 0.312, y: 0.649 },  // 599x701
 { x: 0.423, y: 0.673 },  // 813x727
 { x: 0.522, y: 0.652 },  // 1003x704
 { x: 0.732, y: 0.695 },  // 1406x750
 { x: 0.324, y: 0.716 },  // 623x773
 { x: 0.234, y: 0.744 },  // 449x804
];
export const SONG_LAYOUT = {
  Mars: {
    slotStart: 15,
    count: 11
  },
  Palli: {
    slotStart: 41,
    count: 8
  },
  Agust: {
    slotStart: 31,
    count: 7
  },
  Siggi: {
    slotStart: 0,
    count: 7
  }
};
